import React, { useEffect, useState } from 'react';
import { UpgradePromptModal } from './UpgradePromptModal';

interface SubscriptionEvent {
  message: string;
  feature: string;
}

export function SubscriptionUpgradeListener() {
  const [showModal, setShowModal] = useState(false);
  const [eventData, setEventData] = useState<SubscriptionEvent | null>(null);

  useEffect(() => {
    const handleSubscriptionRequired = (event: CustomEvent<SubscriptionEvent>) => {
      setEventData(event.detail);
      setShowModal(true);
    };

    window.addEventListener('subscription-required', handleSubscriptionRequired as EventListener);

    return () => {
      window.removeEventListener(
        'subscription-required',
        handleSubscriptionRequired as EventListener
      );
    };
  }, []);

  const handleClose = () => {
    setShowModal(false);
    setEventData(null);
  };

  // Determine feature type from event data or API response
  const getFeatureType = (): 'alerts' | 'export' | 'current-data' => {
    if (!eventData) return 'current-data';

    const message = eventData.message.toLowerCase();
    if (message.includes('alert')) return 'alerts';
    if (message.includes('export')) return 'export';
    return 'current-data';
  };

  return (
    <UpgradePromptModal
      isOpen={showModal}
      onClose={handleClose}
      feature={getFeatureType()}
      customMessage={eventData?.message}
    />
  );
}
